import React from "react";
import { useNavigate } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Col,
  Row,
} from "reactstrap";
import styles from "./style.module.scss";

const AccountValidated = props => {
  const navigate = useNavigate();

  return (
    <>    
      <div className={styles.bgContent}>
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="4" md="6">
                <Card className="card-login">
                    <CardHeader>
                      <h3 className="header text-center">Correo Electronico Validado</h3>
                  </CardHeader>
                  <CardBody>
                    <p>
                      <b>
                        Su correo electronico ha sido Validado, ya puede acceder a su cuenta y su casillero en Miami
                      </b>
                    </p>                 
                    <Button 
                    color="primary" 
                    block 
                    className="btn-round mb-3" 
                    onClick={() => navigate("/auth/login")}
                    >                        
                        Iniciar Sesion
                    </Button>
                  </CardBody>
                </Card>
            </Col>
          </Row>
        </Container>
      </div>
      </>
    );
}

export default AccountValidated;
